import { defineMessages } from '@atlassian/jira-intl';

const filterMessages: {
	searchWork: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchWork: {
		id: 'jql-builder-with-ai.filters.search-work',
		defaultMessage: 'Search work',
		description: 'Placeholder for text input to search work items',
	},
});

export default filterMessages;
